import React, { useState } from 'react'
import Webcam from 'react-webcam'
import PrimaryButton from '../primaryButton'

const CameraView = ({ setImgSrc, setView, detail }) => {
  const webcamRef = React.useRef(null)
  const [img, setImg] = useState(null)
  const capture = React.useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot()
    setImg(imageSrc)
  }, [webcamRef, setImg])

  return (
    <>
      {img ? (
        <>
          <div className='flex items-center bg-gray-900 h-3/5 relative'>
            <img className='object-contain' src={img} alt='cargando...' />
          </div>
          <div className='flex flex-col gap-2 justify-center items-center text-center h-2/5 w-full'>
            <h1 className='text-2xl font-bold mb-2'>¿Salió bien?</h1>
            <PrimaryButton
              primaryButtonFunction={() => {
                setImgSrc(img)
                setView('finishView')
              }}
              isDisabled={false}
              margins=''
              buttonText='Si, continuar'
            />
            <PrimaryButton
              primaryButtonFunction={() => {
                setImg(null)
              }}
              outlined
              isDisabled={false}
              margins=''
              buttonText='No, tomar otra foto'
            />
          </div>
        </>
      ) : (
        <>
          <div className='flex justify-center items-center bg-gray-900 w-full h-3/5'>
            <Webcam
              audio={false}
              ref={webcamRef}
              screenshotFormat='image/jpeg'
            />
          </div>
          {/* eslint-disable-next-line */}
          <button onClick={capture} className='h-2/5 mt-10'>
            <div className='h-28 w-28 border-4 border-purple-900 rounded-full flex justify-center items-center '>
              <div className='bg-purple-900 text-white h-24 w-24 rounded-full flex justify-center items-center font-bold' />
            </div>
          </button>
        </>
      )}
    </>
  )
}

export default CameraView
